<template>
    <div v-if="loader" class="preloader active"></div>
    <div v-else class="product-wrapper">
        <div class="row no-gutters">
            <div class="col-lg-6">
                <product-gallery
                    :images="offerSelect.all_images"
                    :is-sale="offerSelect.old_price_value > 0"
                />
            </div>

            <div class="col-lg-6">
                <div class="product-description">
                    <h1 class="product-description__title">{{ productData.name }} </h1>
                    <div class="rating-stars">
                        <div class="rating-stars--fill" :style="{'width': + productData.rating.value*20 + '%'}"></div>
                    </div>
                    <div class="price price--sale">
                        <template v-if="offerSelect.old_price_value > 0">
                            <div class="old"><span>₽ </span>{{ offerSelect.old_price }}</div>
                            <div class="new"><span>₽ </span>{{ offerSelect.price }}</div>
                        </template>
                        <div class="new" v-else><span>₽ </span>{{ offerSelect.price}}</div>
                    </div>
                    <div class="product-form">
                        <label class="product-form-offer-title">
                            Вариант: {{ offerSelect.name }}
                        </label>
                        <product-offers
                            :startingOffer="this.getStartingOffer()"

                        />
                        <div class="status-offer" :class="'status-'+offerSelect.status_id">
                            Статус: {{ getStatusText(offerSelect.status_id) }}
                        </div>

                        <div class="form-row">
                            <input type="number" class="input--sm" step="1" min="1" max="35"
                                   name="quantity"
                                   v-model="count" title="Кол-во" size="4" inputmode="numeric">
                                <div class="btn" v-if="isSwitchButton"><a href="/cart" target="_top">Перейти в корзину</a></div>
                                <div v-else-if="offerSelect.status_id != 0" class="btn _shopaholic-cart-add" @click="addCart()">Добавить в корзину</div>
                                <div v-else class="btn" disabled>Добавить в корзину</div>
                        </div>
                    </div>
                    <ul class="product-meta">
                        <li>Артикул: {{ offerSelect.code }}</li>
                        <li>Бренд:
                             <a target="_top" :href="'/brands/' + productData.brand.slug " class="link">
                                 {{ productData.brand.name }}
                             </a>
                        </li>
                        <li>Категория:
                             <a target="_top" :href="productData.category.url" class="link">
                                 {{ productData.category.name }}
                             </a>
                        </li>
                    </ul>


                    <div class="product-description__tabs-wrap">
                        <ul class="product-description__tabs">
                            <li
                                :class="{active: tabActive==1}"
                                @click="setActiveTab(1)"
                                tab-select="1"
                            > Описание</li>
                            <li
                                :class="{active: tabActive==2}"
                                @click="setActiveTab(2)" tab-select="2"
                                v-if="productData.preview_text"
                            >Дополнительная информация</li>
                            <li
                                :class="{active: tabActive==3}"
                                tab-select="3"
                                @click="setActiveTab(3)"
                            >Отзывы ({{ productData.rating.count }})
                            </li>
                        </ul>

                        <div class="product-description__tabs-page" v-if="tabActive == 1" tab-page="1">
                            <div v-if="productData.description" v-html="productData.description"/>
                            <div v-else>Описание отсутствует</div>
                        </div>
                        <div class="product-description__tabs-page"
                             v-if="tabActive == 2 && productData.preview_text" tab-page="2">
                       <!--     <ul class="product-description__attributes">
                                <li><span class="label">Вес</span><span class="value">.8 kg</span></li>
                                <li><span class="label">Ширина</span><span class="value">.8 kg</span></li>
                                <li><span class="label">Длина</span><span class="value">.8 kg</span></li>
                                <li><span class="label">Прочее</span><span class="value">.8 kg</span></li>
                            </ul>-->
                            {{ productData.preview_text }}
                        </div>
                        <div class="product-description__tabs-page" v-if="tabActive == 3" tab-page="3">
                            <div class="product-description__reviews">

                              <h2 class="product-description__reviews-title">
                                  {{ reviews.items.length }} {{ reviews.textCount }} на этот товар
                              </h2>
                              <ul class="product-description__reviews-list">
                                  <li class="product-description__reviews-item" v-for="(review, index) in reviews.items" :key="review.id">
                                      <div class="product-description__reviews-img">
                                          <img src="/assets/images/avatar-default2.png">
                                      </div>
                                      <div class="product-description__reviews-info">
                                          <div class="rating-stars">
                                              <div class="rating-stars--fill" :style="'width:' + review.rating*20 + '%'"></div>
                                          </div>
                                          <div class="product-description__reviews-name">{{ review.name }}
                                              <div class="product-description__reviews-date">
                                                  {{ review.created_at }}
                                              </div>
                                          </div>
                                          <div class="product-description__reviews-text">
                                              <p>{{ review.comment }}</p>
                                          </div>
                                      </div>
                                  </li>
                              </ul>

                              <div class="product-description__reviews-footer">
                                  <review-form/>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ProductOffers from "../blocks/ProductOffers.vue";
    import ReviewForm from "../blocks/ReviewForm.vue";
    import ProductGallery from "../blocks/ProductGallery.vue";

    export default {
        name: 'Product',
        components: {
            ProductGallery,
            ProductOffers,
            ReviewForm
        },
        props: {},
        data: () => ({
            count: 1,
            loader: true,
            loaderReviews: true,
            tabActive: 1,
            productData: {},
            offers: {},
            images: [],
            isSwitchButton: false,
            order: {
                offerId: '',
                count: 1
            }
        }),
        async mounted() {
            if (!Object.keys(this.$store.getters.productData).length) {
                await this.$store.dispatch('getProductData');
            }
            this.productData = this.$store.getters.productData;

            if (!Object.keys(this.$store.getters.offers).length) {
                await this.$store.dispatch('getOffers', this.productData.id);
            }
            this.offers = this.$store.getters.offers;


            this.$store.commit('setOfferSelect', this.getStartingOffer());

            /*if (!Object.keys(this.$store.getters.offerCart).length) {
                await this.$store.dispatch('getOfferCart');
            }*/
            this.iOffer = this.$store.getters.offerSelect;
            this.loader = false;
            if (!Object.keys(this.$store.getters.reviews).length) {
                this.$store.dispatch('getReviews', this.productData.id);
            }

        },
        computed: {
            offerSelect() {
              return this.$store.getters.offers.filter(s => s.id === this.$store.getters.offerSelect)[0];
            },
            reviews() {
                return this.$store.getters.reviews;
            },
            isCart() {
                return this.$store.getters.offerCart.includes(this.$store.getters.offerSelect);
            }
        },
        watch: {
            offerSelect: function (val) {
                this.isSwitchButton = false;
                this.count = 1;
            }
        },
        methods: {
            getStartingOffer() {
                let inStock = this.offers.filter(o => o.status_id == '1');
                if (!inStock.length) {
                    inStock = this.offers.filter(o => o.status_id == '2');
                }
                if (!inStock.length) {
                    inStock = this.offers.filter(o => o.status_id == '0');
                }
                return inStock[0].id;
            },
            getStatusText(id) {
                if (id == 0) {
                    return 'нет в наличии';
                } else if (id == 1) {
                    return 'в наличии';
                } else if (id == 2) {
                    return 'под заказ';
                }
            },
            setActiveTab(value) {
                this.tabActive = value;
            },
            addCart() {
                ym(68375863,'reachGoal','basket');
                setTimeout(() => this.isSwitchButton = true,200);
            }
        }
    }
</script>
